export const MODE_DIALOG = {
  create: 1,
  edit: 2,
};

export const appInitialState = {
  refresh: false,
  payload: {
    blackboardPresets: [],
    totalNumber: 0,
    totalPages: 0,
  },
  searchOptions: {
    numberPerPage: 100,
    page: 1,
    title: null,
    subtitle: null,
    operatorName: null,
  },
  dialogTarget: {
    open: false,
    mode: MODE_DIALOG.create,
    id: 0,
    showError: false,
    blackboard: {
      id: 0,
      title: '',
      subtitle: '',
      note: '',
      titleSuffix: '',
    },
  },
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'DEFAULT': {
      return { ...state };
    }
    case 'OPEN_BLACKBOARD_LIST_DIALOG': {
      const { refresh } = state;
      return { ...state, refresh: !refresh };
    }
    case 'SUCCESS_API_GET_BLACKBOARD_PRESET_LIST': {
      const { payload = { ...appInitialState.payload } } = action;
      return { ...state, payload };
    }
    case 'SELECT_BLACKBOARD_PAGE': {
      const { page = 1 } = action;
      const searchOptions = { ...state.searchOptions, page };
      const { refresh } = state;
      return { ...state, searchOptions, refresh: !refresh };
    }
    case 'CLOSE_BLACKBOARD_LIST_DIALOG': {
      const { payload, searchOptions } = appInitialState;
      return {
        ...state,
        payload,
        searchOptions,
      };
    }
    case 'UPDATE_BLACKBOARD_SEARCH_OPTIONS': {
      const { option: params } = action;
      const { refresh } = state;
      return {
        ...state,
        searchOptions: { ...state.searchOptions, ...params, page: 1 },
        refresh: !refresh,
      };
    }
    case 'OPEN_BLACKBOARD_REGISTRATION_DIALOG': {
      const { mode, id = 0 } = action.params;
      const { blackboard: initialBlackboard } = appInitialState.dialogTarget;
      const { blackboardPresets = [] } = state.payload;

      const blackboard =
        mode === MODE_DIALOG.create
          ? initialBlackboard
          : blackboardPresets.find(item => item.id === id);
      return {
        ...state,
        dialogTarget: {
          ...appInitialState.dialogTarget,
          mode,
          id,
          open: true,
          blackboard,
        },
      };
    }
    case 'CLOSE_BLACKBOARD_REGISTRATION_DIALOG': {
      const { dialogTarget } = appInitialState;
      return { ...state, dialogTarget };
    }
    case 'EDIT_BLACKBOARD': {
      const { param } = action;
      const { blackboard } = state.dialogTarget;
      const dialogTarget = {
        ...state.dialogTarget,
        blackboard: { ...blackboard, ...param },
        showError: true,
      };
      return { ...state, dialogTarget };
    }
    case 'SUCCESS_API_CREATE_BLACKBOARD':
    case 'SUCCESS_API_UPDATE_BLACKBOARD':
    case 'SUCCESS_API_DELETE_BLACKBOARD': {
      const { refresh } = state;
      const { dialogTarget } = appInitialState;
      return { ...state, refresh: !refresh, dialogTarget };
    }
    default:
      return state;
  }
};
